import { SearchFilterMeta } from 'controllers/SearchController/types';
import {
    FilterFamily,
    FilterWithLabel,
    Filter,
    TagsCategory,
} from 'types/generated/graphql';
import { isFilterFamilty } from 'types/typeGuards/isFilterFamilty';
import { isNotNullOrUndefined } from 'types/typeGuards/isNotNullOrUndefined';
import { ListOfItems } from '../types';

export const getListOfItems = ({
    filters,
    searchFilterMeta,
    isReversed = false,
}: {
    filters?: (FilterFamily | FilterWithLabel | Filter)[];
    searchFilterMeta?: SearchFilterMeta;
    isReversed?: boolean;
}): ListOfItems => {
    if (!filters || !searchFilterMeta) {
        return { list: [] };
    }

    const listItem = filters.filter(isNotNullOrUndefined).map((filter) => ({
        code: filter?.code,
        numberOfResults: filter?.code ? searchFilterMeta[filter?.code] : 0,
        list: isFilterFamilty(filter)
            ? filter?.subFilters
                  ?.filter(isNotNullOrUndefined)
                  .map((subFilter) => {
                      return {
                          code: subFilter?.code,
                          numberOfResults: subFilter?.code
                              ? searchFilterMeta[subFilter.code]
                              : 0,
                      };
                  })
            : [],
    }));

    const listItemReordered = isReversed ? listItem.reverse() : listItem;

    return { list: listItemReordered };
};

export const getListOfTagsCategories = ({
    filters,
    searchFilterMeta,
    isReversed = false,
}: {
    filters?: TagsCategory[];
    searchFilterMeta?: SearchFilterMeta;
    isReversed?: boolean;
}): ListOfItems => {
    if (!filters || !searchFilterMeta) {
        return { list: [] };
    }

    const listItem = filters.filter(isNotNullOrUndefined).map((filter) => {
        const tagsList =
            filter?.list?.filter(isNotNullOrUndefined).map((tag) => {
                const numberOfResults =
                    tag?.code && searchFilterMeta[tag.code] !== undefined
                        ? searchFilterMeta[tag.code]
                        : 0;

                return {
                    code: tag?.code,
                    label: tag?.label,
                    numberOfResults,
                };
            }) ?? [];

        const totalResults = tagsList.reduce(
            (sum, tag) => sum + (tag.numberOfResults || 0),
            0,
        );

        return {
            code: filter?.category,
            numberOfResults: totalResults,
            list: tagsList,
        };
    });

    const listItemReordered = isReversed ? listItem.reverse() : listItem;

    return { list: listItemReordered };
};
